module.exports = __webpack_public_path__ + "static/img/bg-15-2.be1574c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/history-bg/bg-15-2.png
// module id = 36Dj
// module chunks = 0